import { Button } from 'components/shard'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import termsText from './terms_of_service.md'
import { useHistory } from 'react-router'
import auth from 'utils/axios/modules/auth'

const Registration = ({ className }) => {
  const history = useHistory()
  const [terms, setTerms] = React.useState('')

  useEffect(() => {
    fetch(termsText)
      .then((res) => res.text())
      .then((text) => {
        setTerms(text)
      })
  }, [])

  const agreeAndRegister = async () => {
    try {
      const response = await auth.agreeAndRegister()
      if (response) {
        history.push('/top')
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <StyledRegistration className={className}>
      <h1>My TANAKA 登録</h1>
      <p>
        「NINAL マイページ」が「My TANAKA」になりました！
        NINALの契約履歴だけでなく、店頭購入履歴や商品購入時の保証書もこちらで確認できます。
      </p>
      <h2>My TANAKA会員サービス利用規約 </h2>
      <p>下記「My TANAKA利用規約」をご確認のうえ、右下にある「同意して登録する」を押下してください。</p>
      <div className="terms_view">
        <ReactMarkdown>{terms}</ReactMarkdown>
      </div>
      <div className="button_wrapper">
        <Button type="button" width={263} onClick={() => history.push('/login')}>
          キャンセル
        </Button>
        <Button type="button" primary width={263} onClick={agreeAndRegister}>
          同意して登録する
        </Button>
      </div>
    </StyledRegistration>
  )
}

const StyledRegistration = styled.div`
  max-width: 630px;
  margin: 0 auto;
  > h1,
  > h2 {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.44;
    margin-bottom: 20px;
  }
  > h2 {
    margin-top: 40px;
  }
  > p {
    line-height: 24px;
    font-size: 14px;
  }
  .terms_view {
    height: 405px;
    margin-top: 20px;
    margin-bottom: 40px;
    padding: 16px 20px 18px 16px;
    border-radius: 10px;
    border: solid 1px rgba(0, 0, 0, 0.1);
    background-color: #fbfbfb;
    overflow-y: scroll;
    > h1 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    > h2 {
      font-weight: bold;
      margin: 32px 0 8px;
    }
  }
  > .button_wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
`

export default Registration
